import { render, staticRenderFns } from "./IconDateOfBirth.vue?vue&type=template&id=c6e95690"
import script from "./IconDateOfBirth.vue?vue&type=script&lang=js"
export * from "./IconDateOfBirth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports